export default {
  "path": "/demo/iframe-index",
  "meta": {
    "name": "demo-Iframe",
    "title": "Iframe Iframe",
    "isComponentDoc": true,
    "category": "Basic"
  }
};